import {
  Component,
  ElementRef, HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: "SelectInputField",
  templateUrl: './selectinput.component.html',
  styleUrls: ['./selectinput.component.scss'],
})
export class SelectInputField implements OnChanges  {

  @Input() label: any;
  @Input() value: any;
  @Input() icon: string;
  @Input() default: string;
  @Input() error: boolean = false;
  @Input() text: string;
  @Input() controlName: any;
  @Input() parentForm: FormGroup = null;
  @Input() items: any; // [{text: ..., value: ...}, ...s]
  @Input() placeholder: string = "Search..";
  @Input() style: string = "";
  @Input() onChange: any;
  @Input() readonly: boolean = false;
  public open: boolean = false;
  public search: string = "";
  public filteredItems: any[] = [];
  public selectedItem: string = "";
  public selectedValue: string = "";

  constructor(private eRef: ElementRef) {
    this.changeSelect = this.changeSelect.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.getLabel = this.getLabel.bind(this);
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(!this.eRef.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.items){
      this.filteredItems = this.filterByName(changes.items.currentValue, this.search);
    }
    if(changes.default){
      const item = this.items.filter(i => i.value === changes.default.currentValue);
      if (item.length === 1) {
        this.selectedItem = item[0].text;
        this.selectedValue = item[0].value;
      }
    }
    if(changes.value){
      const item = this.items.filter(i => i.value === changes.value.currentValue);
      if (item.length === 1) {
        this.selectedItem = item[0].text;
        this.selectedValue = item[0].value;
      }
    }
  }

  filterByName(items, search){
    if(search == "") {
      return items;
    }
    return items.filter(i => i.text.includes(search) || i.text.toLowerCase().includes(search.toLowerCase()));
  }

  changeSearch(event) {
    const { value } = event.target;
    this.search = value;
    this.filteredItems = this.filterByName(this.items, this.search);
    event.stopPropagation();
    event.preventDefault();
    return false;
  }

  isSelected(value){
    return this.selectedValue === value;
  }

  getLabel(value){
    const item = this.items.filter(i => i.value === value);
    if(item && item.length === 1) {
      return item[0].text;
    } else {
      return this.placeholder;
    }
  }

  changeSelect(value, event) {
    const item =  this.items.filter(i => i.value === value);
    if (item.length === 1) {
      this.selectedItem = item[0].text;
      this.selectedValue = value;
      this.value = value;
      this.onChange(this.selectedValue);
    }
  }

  toggleDropdown(){
    this.open = !this.open;
  }
}
